import {
  Badge,
  Box,
  Flex,
  NumberFormatter,
  Text,
  TextInput,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { _localization } from "../../../../../../config/location";
import { tblPromotionItemPrimaryCommand } from "../../../../../../model/TblPromotion";

const TableItemPrimaryPromotion = ({
  dataPromotionItemPrimaryModels,
  typePromotion,
}: {
  dataPromotionItemPrimaryModels: tblPromotionItemPrimaryCommand[];
  typePromotion: string;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
  const [keySearch, setKeySearch] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [data, setData] = useState<tblPromotionItemPrimaryCommand[]>([]);
  const [dataTemp, setDataTemp] = useState<tblPromotionItemPrimaryCommand[]>(
    []
  );

  const entity: tblPromotionItemPrimaryCommand = {
    id: 0,
    promoteId: null,
    idItemPrimary: null,
    price: null,
    priceNotTakePromote: null,
    discountPercent: null,
    discountAmount: null,
    quantityNeededToBuyRule: null,
    amountNeededToBuyRule: null,
    quantityMin: null,
    quantityMax: null,
    attribute1: null,
    // attribute2: null,
    // attribute3: null,
    // attribute4: null,
    // attribute5: null,
    // attribute6: null,
    // attribute7: null,
    // attribute8: null,
    // attribute9: null,
    // attribute10: null,
    // attribute11: null,
    // attribute12: null,
    // attribute13: null,
    // attribute14: null,
    // attribute15: null,
    itemPrimaryCode: null,
    itemPrimaryName: null,
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      //   {
      //     accessorKey: "apply",
      //     header: "Áp dụng cho",
      //     size: 20,
      //   },
      {
        accessorKey: "itemPrimaryCode",
        header: "Mã hàng",
      },
      {
        accessorKey: "itemPrimaryName",
        header: "Tên hàng",
        size: 500,
      },
      //   {
      //     accessorKey: "startingPrice",
      //     header: "Giá bán từ",
      //   },
      //   {
      //     accessorKey: "finalPrice",
      //     header: "Đến",
      //   },
      //   {
      //     accessorKey: "pointAccumulationRate",
      //     header: "Tỷ lệ tích điểm thưởng",
      //   },
      //   {
      //     accessorKey: "bonusPoints",
      //     header: "Số điểm thưởng",
      //   },
      {
        accessorKey: "discountPercent",
        header: "% chiết khấu",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => `${renderedCellValue || 0} %`,
      },
      {
        accessorKey: "discountAmount",
        header: "Số tiền chiết khấu",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "price",
        header: "Giá tiền áp dụng trong CTKM",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "attribute3",
        header: "Số lượng áp dụng",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "attribute1",
        header: "Số lượng đã bán",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "quantityRemaining",
        header: "Số lượng còn lại",
        enableGlobalFilter: false,
        Cell: ({ row }) => (
          <Text size="11.5px" fw={500}>
            {Number(row.original.attribute3) - Number(row.original.attribute1)}
          </Text>
        ),
      },
      {
        accessorKey: "quantityMin",
        enableGlobalFilter: false,
        header: "SL tối thiểu 1 lần phải mua/1 Đ.Hàng",
      },
      {
        accessorKey: "quantityMax",
        enableGlobalFilter: false,
        header: "SLượng tối đa 1 lần được mua/1 Đ.Hàng",
      },
      {
        accessorKey: "attribute5",
        header: "Thứ tự hiển thị",
      },
      {
        accessorKey: "attribute4",
        header: "Nổi bật",
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue === "Y" ? "green" : "gray"}>
            {renderedCellValue === "Y" ? "Nổi bật" : "Không nổi bật"}
          </Badge>
        ),
      },
      {
        accessorKey: "attribute6",
        header: "Hãng/NCC tài trợ",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
    ],
    []
  );

  const getColumnVisibility = () => {
    if (typePromotion && typePromotion !== "1") {
      return {
        id: false,
        discountPercent: false,
        attribute5: true,
      };
    } else {
      return {
        id: false,
        discountPercent: true,
        attribute5: false,
      };
    }
  };

  const handleChangeSearch = (e: any) => {
    const value = e.target.value.toLowerCase() ?? "";
    setKeySearch(value);
    if (value) {
      const searchResult = dataTemp.filter(
        (product) =>
          product.itemPrimaryCode?.toLowerCase().includes(value) ||
          product.itemPrimaryName?.toLowerCase().includes(value)
      );
      setSelectIds([]);
      table.resetRowSelection();
      setData(searchResult);
    } else {
      setData(dataTemp);
      setSelectIds([]);
      table.resetRowSelection();
    }
  };

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (490 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setDataTemp(dataPromotionItemPrimaryModels);
    setData(dataPromotionItemPrimaryModels);
    setRowCount(dataPromotionItemPrimaryModels.length);
  }, [dataPromotionItemPrimaryModels]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Box>
            <Flex gap="md">
              <TextInput
                placeholder="Nhập từ khoá"
                value={keySearch}
                onChange={handleChangeSearch}
              />

              {/* <TextInput placeholder="Hãng SX" /> */}
            </Flex>
          </Box>
          {/* <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              // await fetchData();
            }}
          >
            Lọc bảng giá
          </Button> */}
        </Flex>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={"flex-end"}
          align="center"
          direction="row"
          wrap="wrap"
        >
          {/* <Button
            leftSection={<IconPlus size={14} />}
            color="blue"
            variant="outline"
            onClick={openSearchItems}
          >
            Thêm mới (F11)
          </Button>

          <Button
            leftSection={<IconTrash size={14} />}
            color="red"
            variant="outline"
            onClick={() => {
              deletesData(selectIds);
            }}
            disabled={selectIds.length < 1}
          >
            Xóa (đã chọn)
          </Button>

          <Button
            leftSection={<IconEdit size={14} />}
            color="green"
            variant="outline"
            onClick={() => openModalItemPrimaryDiscountToAll()}
            disabled={dataTemp.length < 1}
          >
            Thiết lập chiết khấu
          </Button>

          <Menu shadow="md">
            <Menu.Target>
              <Button
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Label>Dữ liệu</Menu.Label>
              <Menu.Item
                leftSection={
                  <IconFileUpload style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Import Excel
              </Menu.Item>
            </Menu.Dropdown>
          </Menu> */}
        </Flex>
      </>
    ),
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowVirtualization: true,
    enableBatchRowSelection: true,
    enablePagination: true,
    enableRowSelection: false,
    getRowId: (row) => row?.idItemPrimary?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [
          "mrt-row-select",
          "apply",
          "itemPrimaryCode",
          "namePurchase",
          "nameManufacturer",
        ],
        right: ["allocationRate", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      showGlobalFilter: true,
    },
    enableGlobalFilter: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        // fontWeight: "bold",
        fontSize: "11px",
        padding: "4px 12px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      // showProgressBars: isRefetching,
      // showSkeletons: isLoading, //loading for the first time with no data
      //   sorting,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: false,
    mantineTableProps: {
      striped: false,
    },
  });

  React.useEffect(() => {
    const newColumnVisibility = getColumnVisibility();
    if (table) {
      table.setColumnVisibility(newColumnVisibility);
    }
  }, [typePromotion, table]);

  return <MantineReactTable table={table} />;
};

export default TableItemPrimaryPromotion;
